export default __webpack_public_path__ + "static/media/error.779ff45d.svg";